<!-- eslint-disable -->
<template>
	<div>
		<h2>{{title}}</h2>
		<p v-if="text.length !== 0" v-bind:key="p[0]" v-for="p in text">
			{{p[0]}}
			<a v-if="p[1] !== ''" :href="link" target="_blank">{{p[1]}}</a>
			{{p[2]}}
		</p>
		<fieldset>
			<legend>Select your preferred method of communications to opt-in</legend>
			<input-group
				v-for="opt in obj" :id="consentId(opt)"
				v-bind:key="consentId(opt)"
				:text="opt" :opt="{type: 'checkbox', name: 'consent', class: 'checkbin'}">
			</input-group>
		</fieldset>
	</div>
</template>

<script>
import inputGroup from './inputGroup.vue'

export default {
	name: 'consentChecks',
	components: {
		inputGroup
	},
	props: {
		obj: Array,
		title: String,
		text: Array,
		link: String
	},
	methods: {
		consentId: function(a) {
			if (a == "Post") {
				return "directMailOptIn";
			} else {
				return a.toLowerCase() + "OptIn";
			}
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
fieldset {
	padding: 0px;
	margin: 0;
}
legend {
	font-size: 1.125rem;
	line-height: 1.75rem;
	font-weight: bold;
	margin: 0;
	padding: 0;
	margin-bottom: 0.5rem;
}
.nontextual {
	padding: 0.5em 0px;
}
</style>
